import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "./AuthContext.js";
import { type DemoUser, authApi } from "./api.js";
import "./LoginScreen.css";

export function LoginScreen(): JSX.Element {
  const { t } = useTranslation();
  const { config, login, loginEntra, loading, error } = useAuth();
  const [users, setUsers] = useState<DemoUser[]>([]);
  const [listError, setListError] = useState<string | null>(null);

  const isDemo = config?.strategy === "demo";

  useEffect(() => {
    if (!isDemo) return;
    let cancelled = false;
    authApi
      .listDemoUsers()
      .then((res) => {
        if (!cancelled) setUsers(res.users);
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setListError(err instanceof Error ? err.message : String(err));
        }
      });
    return () => {
      cancelled = true;
    };
  }, [isDemo]);

  return (
    <main className="login-screen">
      <div className="login-card">
        <div className="login-banner">
          {isDemo ? t("auth.banner.demo") : t("auth.banner.entra")}
        </div>
        <h1>{t("auth.signin.title")}</h1>
        <p className="login-subtitle">
          {isDemo ? t("auth.signin.subtitle") : t("auth.signin.subtitleEntra")}
        </p>

        {error ? (
          <div className="login-error" role="alert">
            {t(isDemo ? "auth.error.login" : "auth.error.entra")}
            {!isDemo ? "" : `: ${error}`}
          </div>
        ) : null}

        {isDemo ? (
          <>
            {listError ? (
              <div className="login-error" role="alert">
                {t("auth.error.list")}: {listError}
              </div>
            ) : null}
            <ul className="login-users">
              {users.map((u) => (
                <li key={u.id}>
                  <button
                    type="button"
                    className="login-user-btn"
                    disabled={loading}
                    onClick={() => {
                      void login(u.id);
                    }}
                  >
                    <span className="login-user-name">{u.displayName}</span>
                    <span className="login-user-email">{u.email}</span>
                  </button>
                </li>
              ))}
              {users.length === 0 && !listError ? (
                <li className="login-empty">{t("auth.loading")}</li>
              ) : null}
            </ul>
          </>
        ) : config?.strategy === "entra" ? (
          <button
            type="button"
            className="login-entra-btn"
            disabled={loading}
            onClick={() => {
              void loginEntra();
            }}
          >
            {t("auth.signin.microsoft")}
          </button>
        ) : (
          <p className="login-empty">{t("auth.loading")}</p>
        )}
      </div>
    </main>
  );
}
